import React from "react";
import axios from "@/utils/myaxios";
import moment from "moment";
import { Link } from "react-router-dom";
import { tableSummaries, isMobileDevice } from "@/utils/utils";
import {
    message,
    Card,
    Switch,
    Button,
    Form,
    Modal,
    InputNumber,
    Spin,
    Statistic,
    Table,
    Row,
} from "antd";

export default class ActivityLuckycard extends React.Component {
    state = {
        loading: false, // 是否加载中
        dataInfo: {}, // 数据信息
    };

    componentDidMount () {
        this.fetchDataInfo();
    }

    /**
     * 获取数据
     */
    fetchDataInfo = () => {
        this.setState({ loading: true });
        axios.get("/v1/api/activity_get_lucky_card_conf").then((res) => {
            this.setState({
                loading: false,
                dataInfo: res.data || {},
            });
        });
    };

    /**
     * 更新配置
     */
    handleUpdateConfig = (key, value) => {
        axios
            .patch("/v1/api/activity_set_lucky_card_conf", {
                is_open_nlh: this.state.dataInfo.is_open_nlh,
                is_open_aof: this.state.dataInfo.is_open_aof,
                is_open_plo: this.state.dataInfo.is_open_plo,
                [key]: value,
            })
            .then((res) => {
                if (res.code === 1) {
                    message.success(this.props.language["operationSuccessMessage"]);
                    this.fetchDataInfo();
                }
            });
    };

    /**
     * 充值奖池数量
     */
    handleRechargePool = () => {
        this.formRef.props.form.validateFields((err, values) => {
            if (!err) {
                if (values.recharge_amount > this.state.dataInfo.super_union_point)
                    return message.error(
                        this.props.language["insufficientPointsMessage"]
                    );
                Modal.confirm({
                    title: this.props.language["hint"],
                    content: this.props.getLanguage(
                        "rechargeIntegralConfirm",
                        values.recharge_amount
                    ),
                    onOk: () => {
                        axios
                            .patch("/v1/api/activity_set_lucky_card_conf", {
                                is_open_nlh: this.state.dataInfo.is_open_nlh,
                                is_open_aof: this.state.dataInfo.is_open_aof,
                                is_open_plo: this.state.dataInfo.is_open_plo,
                                recharge_amount: values.recharge_amount,
                            })
                            .then((res) => {
                                if (res.code === 1) {
                                    message.success(
                                        this.props.language["rechargeSuccessMessage"]
                                    );
                                    this.formRef.props.form.resetFields();
                                    this.fetchDataInfo();
                                }
                            });
                    },
                });
            }
        });
    };

    render () {
        return (
            <Spin spinning={this.state.loading}>
                <div className='p10'>
                    {/* 当前奖池 */}
                    <Card
                        title={
                            <h2>
                                {this.props.language["currentPrizePool"]}
                            </h2>
                        }
                        type="inner"
                    >
                        <Row type="flex" align="middle">
                            <div className="number-box-list">
                                <div className="value-list">
                                    <div className="value-item">
                                        <Statistic
                                            value={Number(this.state.dataInfo.bonus_in_pool || 0)}
                                        />
                                        <p className="label">
                                            {this.props.language["currentPrizePool"]}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="number-box-list">
                                <div className="value-list">
                                    <div className="value-item">
                                        <h1 className="value">{this.state.dataInfo.cards}</h1>
                                        <p className="label">
                                            {this.props.language["currentLunckyCard"]}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </Row>
                    </Card>

                    {/* 充值奖池 */}
                    <Card
                        className="mt20"
                        title={
                            <Row type="flex" align="middle">
                                <h2>
                                    {this.props.language["rechargePrizePool"]}
                                </h2>
                                <h3>
                                    （{this.props.language["counterPoint"]}：
                                    {this.state.dataInfo.super_union_point}）
                                </h3>
                            </Row>
                        }
                        type="inner"
                    >
                        <PoolForm
                            {...this.props}
                            onOk={this.handleRechargePool}
                            dataInfo={this.state.dataInfo}
                            wrappedComponentRef={(formRef) => (this.formRef = formRef)}
                        />
                    </Card>

                    {/* 活动开关 */}
                    <Card
                        className="mt20"
                        title={
                            <h2>{this.props.language["activitySwitch"]}</h2>
                        }
                        type="inner"
                    >
                        <Row className='mb10' type="flex" align="middle" justify="space-between">
                            <h3>NLH</h3>
                            <Switch
                                checked={this.state.dataInfo && this.state.dataInfo.is_open_nlh}
                                onChange={(value) =>
                                    this.handleUpdateConfig("is_open_nlh", value)
                                }
                            />
                        </Row>
                        <Row className='mb10' type="flex" align="middle" justify="space-between">
                            <h3>AOF</h3>
                            <Switch
                                checked={this.state.dataInfo && this.state.dataInfo.is_open_aof}
                                onChange={(value) =>
                                    this.handleUpdateConfig("is_open_aof", value)
                                }
                            />
                        </Row>
                        <Row type="flex" align="middle" justify="space-between">
                            <h3>PLO</h3>
                            <Switch
                                checked={this.state.dataInfo && this.state.dataInfo.is_open_plo}
                                onChange={(value) =>
                                    this.handleUpdateConfig("is_open_plo", value)
                                }
                            />
                        </Row>
                    </Card>

                    {/* 活动说明 */}
                    <Card
                        className="mt20"
                        title={
                            <h2>
                                {this.props.language["activityDescription"]}
                            </h2>
                        }
                        type="inner"
                    >
                        <h4>{this.props.language["activityDescription1"]}</h4>
                        <h4>{this.props.language["activityDescription2"]}</h4>
                        <h4>{this.props.language["activityDescription3"]}</h4>
                        <h3 className="mt20">
                            {this.props.language["serviceFeeAndBonus"]}
                        </h3>
                        <Table scroll={{ x: true }}
                            rowKey={(record, index) => index} className="mt10" bordered size="small" pagination={false} dataSource={[
                                {
                                    blindBet: '≤0.4/0.8',
                                    serviceFee: '0.8BB',
                                    prizeTwoCount: '2BB',
                                    prizeTenCount: '1%',
                                    prizeType3: '2%',
                                },
                                {
                                    blindBet: '0.5/1 - 1/2',
                                    serviceFee: '0.6BB',
                                    prizeTwoCount: '2BB',
                                    prizeTenCount: '2%',
                                    prizeType3: '4%',
                                },
                                {
                                    blindBet: '2/4 - 5/10',
                                    serviceFee: '0.4BB',
                                    prizeTwoCount: '2BB',
                                    prizeTenCount: '3.5%',
                                    prizeType3: '7%',
                                },
                                {
                                    blindBet: '10/20 - 25/50',
                                    serviceFee: '0.25BB',
                                    prizeTwoCount: '2BB',
                                    prizeTenCount: '5.5%',
                                    prizeType3: '11%',
                                },
                                {
                                    blindBet: '50/100 - 100/200',
                                    serviceFee: '0.12BB',
                                    prizeTwoCount: '2BB',
                                    prizeTenCount: '7%',
                                    prizeType3: '14%',
                                },
                                {
                                    blindBet: '≥150/300',
                                    serviceFee: '0.06BB',
                                    prizeTwoCount: '2BB',
                                    prizeTenCount: '8.5%',
                                    prizeType3: '17%',
                                },
                            ]}>
                            <Table.Column align="center" title={this.props.language["blindBet"]} dataIndex="blindBet" />
                            <Table.Column align="center" title={this.props.language["serviceFee"]} dataIndex="serviceFee" />
                            <Table.ColumnGroup title={this.props.language["prizeCount"]}>
                                <Table.Column align="center" title={this.props.language["prizeTwoCount"]} dataIndex="prizeTwoCount" />
                                <Table.Column align="center" title={this.props.language["prizeTenCount"]} dataIndex="prizeTenCount" />
                                <Table.Column align="center" title={this.props.language["prizeType3"]} dataIndex="prizeType3" />
                            </Table.ColumnGroup>
                        </Table>
                    </Card>
                </div>
            </Spin>
        );
    }
}

/**
 * 充值奖池表单
 */
const PoolForm = Form.create({ name: "pool_form_box" })(
    class FormBox extends React.Component {
        render () {
            const { getFieldDecorator } = this.props.form;
            return (
                <Form layout="inline">
                    <Form.Item type="number">
                        {getFieldDecorator("recharge_amount", {
                            rules: [
                                {
                                    required: true,
                                    message: this.props.language["rechargeAmountVerify"],
                                },
                            ],
                        })(
                            <InputNumber
                                min={1}
                                max={100000000}
                                precision={0}
                                placeholder={this.props.language["rechargeAmountPlaceholder"]}
                            />
                        )}
                    </Form.Item>
                    <Form.Item>
                        <Button type="primary" onClick={this.props.onOk}>
                            {this.props.language["recharge"]}
                        </Button>
                    </Form.Item>
                </Form>
            );
        }
    }
);
